import { render, staticRenderFns } from "./ListAdmin.vue?vue&type=template&id=a938b20a&scoped=true&"
import script from "./ListAdmin.vue?vue&type=script&lang=js&"
export * from "./ListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ListAdmin.vue?vue&type=style&index=0&id=a938b20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a938b20a",
  null
  
)

export default component.exports